import { GridColDef } from "@mui/x-data-grid";
import { TbUser } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { User } from "@/types/user.types";

function RenderCell({ value }: { value: string }) {
    return (
        <div className=" font-medium flex items-center text-gray-600 italic h-full pl-2 text-sm   break-all">
            {value}
        </div>
    );
}
export const UserIdentityNoColumn = (): GridColDef<User> => {
    return {
        field: "identityNumber",
        headerName: "citizen_id",
        minWidth: 140,
        valueGetter: (_value, row) => row.identityNumber,
        renderHeader: (params) => <TableHeader Component={TbUser} title={params.colDef.headerName!} />,
        renderCell: ({ value }) => <RenderCell value={value} />,
    };
};
